import React from "react";
import { useNavigate } from "react-router-dom";
import { HiOutlineHome } from "react-icons/hi2";
import { APP_ROUTES } from "../../data-access";
import { FormButton } from "../../ui";
import "./nothing-found.scss";

export const NothingFound = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <div className="nothing-found">
      {/* Stars */}
      <div className="nothing-found__stars">
        {Array.from({ length: 30 }, (_, i) => (
          <div key={i} className="nothing-found__star" />
        ))}
      </div>

      <div className="nothing-found__container">
        {/* Astronaut scene */}
        <div className="nothing-found__scene">
          <div className="nothing-found__planet">
            <div className="nothing-found__crater nothing-found__crater--1" />
            <div className="nothing-found__crater nothing-found__crater--2" />
            <div className="nothing-found__crater nothing-found__crater--3" />
          </div>
          <div className="nothing-found__orbit" />
          <div className="nothing-found__astronaut">
            <div className="nothing-found__helmet">
              <div className="nothing-found__visor" />
            </div>
            <div className="nothing-found__body" />
            <div className="nothing-found__arm nothing-found__arm--left" />
            <div className="nothing-found__arm nothing-found__arm--right" />
            <div className="nothing-found__leg nothing-found__leg--left" />
            <div className="nothing-found__leg nothing-found__leg--right" />
          </div>
          <div className="nothing-found__flag">
            <div className="nothing-found__flag-pole" />
            <div className="nothing-found__flag-cloth">404</div>
          </div>
        </div>

        <h1 className="nothing-found__title">Lost in Space</h1>
        <p className="nothing-found__desc">
          Houston, we have a problem. This page doesn't exist or has been moved
          to another galaxy.
        </p>

        <FormButton
          theme="green-light"
          onClick={() => navigate(APP_ROUTES.dashboard)}
          className="nothing-found__btn"
        >
          <HiOutlineHome size={18} />
          Go Home
        </FormButton>
      </div>
    </div>
  );
};

export default NothingFound;
